// src/Dashboard/pages/user/Messaging/components/ChatMessageBubble.jsx

import React from "react";
import { FaTrash } from "react-icons/fa";

import {
  formatMessageDate,
  formatMessageTime,
  getMessageDateValue,
  getUserAvatar,
  getUserFullName,
} from "../utils/messagingUtils";

export default function ChatMessageBubble({ message, canDelete, onDelete }) {
  if (!message) return null;

  const isMine = Number(message.user_id) === Number(message.currentUserId);
  const user = message.Users || message.User || {};

  return (
    <div className={`flex w-full ${isMine ? "justify-end" : "justify-start"}`}>
      <div
        className={`flex max-w-[88%] gap-2 sm:max-w-[72%] ${
          isMine ? "flex-row-reverse" : "flex-row"
        }`}
      >
        <img
          src={getUserAvatar(user)}
          alt={getUserFullName(user)}
          className="mt-5 h-8 w-8 shrink-0 rounded-xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
        />

        <div className={isMine ? "items-end text-right" : "items-start text-left"}>
          <div
            className={`mb-1 flex items-center gap-2 text-[11px] text-slate-500 dark:text-slate-400 ${
              isMine ? "justify-end" : "justify-start"
            }`}
          >
            <span className="font-bold">
              {isMine ? "Moi" : getUserFullName(user)}
            </span>

            <span>
              {formatMessageDate(getMessageDateValue(message))} ·{" "}
              {formatMessageTime(getMessageDateValue(message))}
            </span>

            {canDelete && (
              <button
                type="button"
                onClick={onDelete}
                className="inline-flex items-center gap-1 text-red-500 transition hover:text-red-700"
                title="Supprimer"
              >
                <FaTrash />
              </button>
            )}
          </div>

          <div
            className={`rounded-[20px] px-4 py-3 text-sm leading-6 shadow-sm ${
              isMine
                ? "rounded-tr-md bg-[#013E8E] text-white"
                : "rounded-tl-md bg-white text-slate-700 ring-1 ring-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-800"
            }`}
            style={{ wordBreak: "break-word" }}
          >
            {message.message}
          </div>

          {message._optimistic && (
            <p className="mt-1 text-[11px] text-slate-400">Envoi en cours...</p>
          )}
        </div>
      </div>
    </div>
  );
}